import Toast from '@/components/Toast';
import { ToastObjInstanceType, ToastType } from '@/components/Toast/typings';
import { ComponentPublicInstance } from 'vue';
export function useToast() {
  const { close, comfirm, loading, warning, success, error } = Toast as unknown as ComponentPublicInstance &
    Required<ToastObjInstanceType> &
    Required<ToastType>;
  const server = Toast;
  return {
    close,
    comfirm,
    loading,
    warning,
    success,
    error,
    server,
  };
}
